import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';

const CambioPasswordUser = (p) => {
    const show_dialog = p.show_dialog;
    const [loader, setloader] = useState(false);
    const [password_form, setpassword_form] = useState({ password: "", new_password: "" });
    useEffect(() => {

    }, []);
    const submit = (event) => {
        event.preventDefault();
        if (password_form.password.length < 6 || password_form.password.length > 60) {
            show_dialog("Error", "La contraseña debe tener entre 6 y 60 caracteres");
            return;
        }

        if (password_form.new_password.length < 6 || password_form.new_password.length > 60) {
            show_dialog("Error", "La nueva contraseña debe tener entre 6 y 60 caracteres");
            return;
        }

        if (password_form.new_password === password_form.password) {
            show_dialog("Error", "La nueva contraseña no puede ser identica a la contraseña actual");
            return;
        }

        Post("secure/change_password", { ...password_form }, setloader).then((resp) => {
            if (resp.estatus) {
                show_dialog("Actualización exitosa", "La próxima vez que inicie sesión podrá utilizar la nueva contraseña", "success");
                setpassword_form({ password: "", new_password: "" });
                return;
            }
            show_dialog("Ocurrió un error", resp.msj ? resp.msj : "Error de conexión");
        })

    }

    const change = (event) => {
        let pss = { ...password_form };
        pss[event.target.name] = event.target.value;
        setpassword_form(pss);
    }


    return (

        <form className='bw-1200 p-1 border bg-white2 round-s shadow-multi text-center blur-m' onSubmit={submit}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='col-lg-12 dosis h4 text-center'>Cambiar contraseña</div>
                <div className='w-90 mb-3 border-bottom border-warning '>
                    Actualice su contraseña de aceso, introduzca su contraseña actual y la nueva contraeña antes de pulsar el botón
                    <span className='text-bold ps-2'>'Actualizar'</span>
                </div>
                <div className='bw-600 m-0 p-0 round-s  mb-3'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='form-group col-md-10 m-0 mt-3'>
                            <label className='text-bold w-100 text-start'>Contraseña actual</label>
                            <input type='password' className='form-control border shadow-sm' name='password' value={password_form.password} minLength={6} maxLength={60} onChange={change} />
                        </div>
                        <div className='form-group col-md-10 m-0 mt-3'>
                            <label className='text-bold w-100 text-start'>Nueva contraseña</label>
                            <input type='password' className='form-control border shadow-sm' name="new_password" value={password_form.new_password} minLength={6} maxLength={60} onChange={change} />
                        </div>
                        <div className='col-auto mb-3 mt-3'>
                            <button className='btn btn-warning shadow ps-5 pe-5 text-bold text-pink4 border scale-025 round-xxl border border-dark' type='submit'
                                disabled={password_form.new_password === "" || password_form.password == ""}>Actualizar</button>
                        </div>
                    </div>
                </div>

            </div>
            {loader && <div className='blur-s w-100 h-100' style={{ position: 'fixed', left: 0, top: 0 }}><div className='loader-local'></div></div>}
        </form>

    )
}

export default CambioPasswordUser;